<template>
  <div class="quiz-box">
    <div class="quiz-box-main">
      <ul v-if="subType !== 'schedule' && rounds && rounds.length !== 0" class="matchList">
        <!-- 局数标签 -->
        <li
          v-for="(match, key) in rounds"
          :key="key"
          :class="{ active: match.matchCode === subMatch }"
          @click="switchMatch(match.matchCode)"
        >
          <UiLabel>{{ match.name }}</UiLabel>
        </li>
      </ul>

      <div class="quiz-list" v-if="quizList && quizList.length !== 0">
        <!-- quiz-coin 放 list 内部 (随内容滚动), 权宜方案见下面注释. 前置放置让最后一张 quizCard 自然做 :last-child, 避免 selector 用 nth-魔术数字 -->
        <QuizCoin />
        <!-- 竞猜内容 -->
        <CardContainer v-for="(item, key) in quizList" :key="key" :info="item">
          <AllTeams v-if="item.stype === 1" :info="item" :list="item.teamList"></AllTeams>
          <!-- PK 卡: 单对象(type=2) / 排名PK(type=3) / 淘汰PK(type=4) 三份克隆合一 -->
          <PkCard
            v-else-if="item.stype === 2"
            :info="item"
            :variant="item.type === 2 ? 'single' : item.type === 3 ? 'rank' : 'disuse'"
          />
        </CardContainer>
      </div>
      <UiEmpty v-else-if="!isLoading" tip="暂无竞猜内容" />
    </div>

    <!--
      quiz-coin 位置说明:
      曾尝试放在这里 (quiz-box 直接子, 和 quiz-box-tip 同级) 做常驻角标, 独立于 tab 内容/空态分支.
      但 quiz-list 滚动时 absolute 定位的 coin 位置不变, 内容会滚到 coin 下方产生视觉重叠.
      权宜方案: 复用回 quiz-list 内部 (随内容一起滚动, 滚出视野即消失).
      这种"依赖内容滚动带走 coin"的耦合不认可, 暂无好方案先保留.
    -->

    <div class="quiz-box-tip">
      <i></i>
      <UiLabel shadow-color="#880000" text-color="#FFFFFF">
        参与竞猜可获得“竞猜币”，免费兑换「糖果」「赛事币」「占卜币」「缤纷补给箱钥匙」等奖励！
      </UiLabel>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import CardContainer from '@/views/quiz/layout/card-container';
import AllTeams from '@/views/quiz/type/all-teams';
import PkCard from '@/views/quiz/type/pk-card';
import UiEmpty from '@/components/ui-empty';
import UiLabel from '@/components/ui-label';
import QuizCoin from '@/views/quiz/layout/quiz-coin';
// type 竞猜类别(1: 赛程竞猜，2: 实时竞猜，3: 排名PK，4: 淘汰PK)
// stype 竞猜子类别(1: 多项竞猜[队伍列表], 2: 单项竞猜[单个队伍/队员])

const switchMatch = inject("switchMatch");

// provide() {
//     return {
//         displaySelect: this.displaySelect
//     }
// },
defineProps({
  subType: {
    type: String,
    default: () => ''
  },
  rounds: {
    type: Array,
    default: () => []
  },
  subMatch: {
    type: [Number, String],
    default: () => 0
  },
  quizList: {
    type: Array,
    default: () => []
  },
  quizSchedule: {
    type: Array,
    default: () => []
  },
  subSchedule: {
    type: Object,
    default: () => { }
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  // showSelect: {
  //     type: Boolean,
  //     default: () => {}
  // }

});

</script>

<style lang="scss" scoped>
.quiz-box {
  box-sizing: border-box;
  width: get_vw(1396);
  height: calc(100% - #{get_vh(25)});
  margin-top: get_vh(25);
  display: flex;
  flex-direction: column;

  .quiz-box-main {
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    @include r(padding-bottom, 76);
    display: flex;

    .matchList {
      width: get_vw(156);
      height: fit-content;
      position: relative;
      isolation: isolate;
      flex-shrink: 0;
      flex-grow: 0;
      margin-left: get_vw(12);
      margin-right: get_vw(36);
      transform: translateY(get_vw(-3));
      font-size: get_vw(26);
      --label-shadow-color: #6A1110;
      --label-text-color: #fff;

      // 异形背景独立层, top/height 可独立调节, 不受 li 内容撑起的容器边界限制
      &::before {
        content: '';
        position: absolute;
        top: get_vw(6);
        left: 0;
        width: 100%;
        height: 100%;
        background: url(https://website.xdcdn.net/poster/58881/26match/common/QSSdZhau.png) center/100% 100% no-repeat;
        z-index: -1;
        pointer-events: none;
        filter: drop-shadow(0 get_vw(2) get_vw(4) rgba(#000, 0.25));
      }

      li {
          position: relative;
          isolation: isolate;
          width: 100%;
          height: get_vw(73);
          border-radius: get_vw(10);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          // 底部分隔线
          &::after {
            content: '';
            position: absolute;
            bottom: get_vw(0);
            left: 50%;
            transform: translateX(-50%);
            width: get_vw(116);
            height: get_vw(2);
            background-color: #6A1110;
          }

          // 选中态叠加背景
          &::before {
            content: '';
            position: absolute;
            top: get_vw(0);
            left: get_vw(-12);
            width: get_vw(187);
            height: 100%;
            background: url(https://website.xdcdn.net/poster/58881/26match/common/QSSdZg93.png) center/contain no-repeat;
            opacity: 0;
            transition: opacity ease-in-out 100ms;
            z-index: -1;
            pointer-events: none;
            filter: drop-shadow(0 get_vw(4) get_vw(4) rgba(#000, 0.2));
          }

          &:last-child::after {
            display: none;
          }

          &.active {
            --label-shadow-color: #{rgba(#FFFFFF, 0.7)};
            --label-text-color: #513718;
            &::after { display: none; }
            &::before { opacity: 1; }
            .label-box {
              transform: translateY(-4%);
            }
          }
        }
      }

    .quiz-list {
      position: relative;
      flex: 1;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      @include hideScrollBar;
    }
  }
  .quiz-box-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    @include r(height, 76);
    display: flex;
    justify-content: center;
    align-items: center;
    @include r(font-size, 20);

    i {
      display: inline-block;
      @include r(width, 22);
      @include r(height, 22);
      background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QYOQFqp3.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @include r(margin-right, 10);
    }
    // label 颜色由 ui-label prop 决定
  }
}
</style>
